import React from "react";

export default () => (
  <svg width="100%" height="100%" viewBox="0 0 120 120">
    <path
      fill="#be45b0"
      d="M60.35 18a42 42 0 11-41.66 42 41.83 41.83 0 0141.66-42zM60 37.44A22.56 22.56 0 1082.56 60 22.56 22.56 0 0060 37.44z"
    />
    <path
      fill="#f29f0c"
      d="M59.87 18l.22 19.44H60a22.56 22.56 0 000 45.12h.35c0 11.26-.14 19.44-.48 19.44C38.5 102 18 83.2 18 60a41.94 41.94 0 0141.87-42z"
    />
    <path
      fill="#ff7826"
      d="M18.05 59.65c.68 0 8.25.16 19.39.26V60A22.56 22.56 0 0060 82.56h.29c.12 10 .09 19.44-.42 19.44C38.5 102 18 83 18 59.65h.05z"
    />
    <path
      fill="#fa4e7c"
      d="M60 82.56h.29c0 2.62.05 5.22.06 7.61v1.68c0 5.85-.14 10.15-.48 10.15-13.73 0-27.09-7.77-34.93-19.5l16-10.45A22.54 22.54 0 0060 82.56z"
    />
    <circle
      cx="60"
      cy="60"
      r="37.4"
      fill="none"
      stroke="#fff"
      strokeWidth="9"
      opacity=".2"
    />
    <path
      fill="#be45b0"
      d="M79.54 99.43L83 110l-10.46 3.4-3.36-10.35a43.8 43.8 0 0010.36-3.62zm12.84-9.64L96 94.08l-8.43 7.07L84 96.89a43.91 43.91 0 008.38-7.1zm14.13-48l2.66 10.68-5.59 1.39a43.37 43.37 0 00-2.87-10.62zM97.79 23.4l6.62 8.78-6.74 5.08a43.87 43.87 0 00-6.82-8.63zM84.29 7.82L94 13l-6.66 12.52a44 44 0 00-9.42-5.72z"
    />
    <path
      fill="#f29f0c"
      d="M26.19 36.8L23 42.37a42.19 42.19 0 013.19-5.57zm-13-11.44l12.45 7.19a43.67 43.67 0 00-5.74 9.39l-12.21-7zM27.14 8l10.61 14A43.88 43.88 0 0029 28.75L18.36 14.59z"
    />
    <path
      fill="#fa4e7c"
      d="M47.94 102.33l-3 7.43-10.2-4.12L37.82 98a43.71 43.71 0 0010.12 4.33zm-12.26-5.66l-9.33 10.73-8.3-7.22 9.29-10.69a44.32 44.32 0 008.34 7.18zm5-.49l8.09 3.26a40.27 40.27 0 01-8.08-3.26zm-10.11-7.64l5.27 4.59a41.08 41.08 0 01-5.27-4.59z"
    />
  </svg>
);
